/*
  @ Add body class if:
  - scroll started
  - scrolled to bottom
*/

const START_OFFSET = 187;
const START_CLASS = "is-scrolled";
const BOTTOM_OFFSET = 187;
const BOTTOM_CLASS = "is-scrolled-bottom";

class ScrollClass {
  constructor() {
    document.addEventListener("scroll", this.scrollHandler, false);
  }

  scrollHandler = () => {
    const top = document.documentElement.scrollTop;

    document.body.classList.toggle(START_CLASS, top >= START_OFFSET);
    document.body.classList.toggle(
      BOTTOM_CLASS,
      window.innerHeight + top >= document.body.offsetHeight - BOTTOM_OFFSET
    );
  };
}

new ScrollClass();
